import querystring from 'query-string';

import searchQuerySchema from '../routes/SearchPage/searchQuerySchema';
import type { SearchFilters } from '../types/search';
import { notifyBugsnagHandledError } from './bugsnagClient';

const queryToSearchFilters = (query?: string): SearchFilters => {
	if (!query) {
		return searchQuerySchema.cast({});
	}

	try {
		const parsedFilters = querystring.parse(query, { arrayFormat: 'comma' });
		return searchQuerySchema.cast(parsedFilters);
	} catch (error) {
		// A malformed (e.g. double-encoded) query string can make a typed cast throw
		// (SEAR-518) inside the render path. Degrade to default filters instead of
		// crashing the page; report as a handled error — with the offending query
		// attached — so we can still spot the bad URLs and their source.
		const err = error instanceof Error ? error : new Error(String(error));
		err.message = `queryToSearchFilters failed for query "${query}": ${err.message}`;
		notifyBugsnagHandledError(err);
		return searchQuerySchema.cast({});
	}
};

export default queryToSearchFilters;
